import * as React from 'react';

import { type UseFormReturn } from 'react-hook-form';
import { useIntl } from 'react-intl';

import {
    ALLOW_LIST_TYPE,
    ALLOW_LIST_PURPOSE,
    ALLOW_LIST_PURPOSE_TRANSLATION_MAP,
    ALLOW_LIST_TYPE_TRANSLATION_MAP,
} from 'src/features/parkingManagement/types/allowList';
import { allowListMessages } from 'src/features/parkingManagement/utils/allowListMessages';
import InputFormField from 'src/registry/components/forms/InputFormField';
import MultiSelectFormField from 'src/registry/components/forms/MultiSelectFormField.tsx';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { Form } from 'src/registry/ui/Form';
import { generalMessages } from 'src/utils/messages';

import type { AllowListFormSchemaValues } from 'src/features/parkingManagement/api/AllowListAPI/useCreateAllowList';

type AllowListFormProps = {
    form: UseFormReturn<AllowListFormSchemaValues>;
    onSubmit: (values: AllowListFormSchemaValues) => void;
};

export default function AllowListForm({ onSubmit, form }: AllowListFormProps) {
    const { formatMessage } = useIntl();

    const options = [
        {
            name: formatMessage(ALLOW_LIST_PURPOSE_TRANSLATION_MAP[ALLOW_LIST_PURPOSE.RESERVATION]),
            id: ALLOW_LIST_PURPOSE.RESERVATION,
        },
        {
            name: formatMessage(ALLOW_LIST_PURPOSE_TRANSLATION_MAP[ALLOW_LIST_PURPOSE.SUBSCRIPTION]),
            id: ALLOW_LIST_PURPOSE.SUBSCRIPTION,
        },
        {
            name: formatMessage(ALLOW_LIST_PURPOSE_TRANSLATION_MAP[ALLOW_LIST_PURPOSE.EV]),
            id: ALLOW_LIST_PURPOSE.EV,
        },
        {
            name: formatMessage(ALLOW_LIST_PURPOSE_TRANSLATION_MAP[ALLOW_LIST_PURPOSE.ENTRANCE]),
            id: ALLOW_LIST_PURPOSE.ENTRANCE,
        },
    ];

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<AllowListFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(generalMessages.name)}
            />
            <SelectFormField<AllowListFormSchemaValues>
                form={form}
                name="type"
                label={formatMessage(allowListMessages.type)}
                options={Object.values(ALLOW_LIST_TYPE)}
                optionTranslationMap={ALLOW_LIST_TYPE_TRANSLATION_MAP}
            />
            <MultiSelectFormField<AllowListFormSchemaValues>
                form={form}
                name="purposes"
                label={formatMessage(allowListMessages.purposes)}
                options={options}
                optionTranslationMap={ALLOW_LIST_PURPOSE_TRANSLATION_MAP}
            />
        </Form>
    );
}
